module.exports = __webpack_public_path__ + "media/2-9.07ed1d7d.wav";